import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import FintooBackButton from "../../HTML/FintooBackButton";
import commonEncode from "../../../commonEncode";
import { DATA_BELONGS_TO } from "../../../constants";
import axios from "axios";
import moment from "moment";
import { fetchEncryptData, apiCall, getUserId, getItemLocal } from "../../../common_utilities";
import { useNavigate } from "react-router-dom";
import { sendMail } from "../../../FrappeIntegration-Services/services/user-management-api/userApiService";
import { SendSMs } from "../../../FrappeIntegration-Services/services/financial-planning-api/ndaflow";

const Twofactorotpverification = (props) => {
  // 
  const timer = useRef({ obj: null, counter: 120, default: 120 });
  const [count, setCount] = useState(120);
  const [useremail, setuseremail] = useState("");
  const [usermobile, setusermobile] = useState("");
  const [generateotp, setGeneratedSmsOTP] = useState("");
  const [generatedemailotp, setGeneratedEmailOTP] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [validOtp, setValidOtp] = useState(true);
  const navigate = useNavigate();
  const [nomineeflag, setnomineeflag] = useState("");
  const [username, SetName] = useState("");

  const user_data = JSON.parse(localStorage.getItem("user_data"));

  console.log("user_data", user_data)
  

  useEffect(() => {
    onLoadInIt();
    fetchMail();
    fetchSms();
  }, [useremail]);

  useEffect(() => {
    var count = commonEncode.decrypt(localStorage.getItem('cart_amt'))
    console.log(count, "helooo")
  })

  const randomOTP = useRef(Math.floor(Math.random() * 90000) + 10000);

  console.log("randomOTP", randomOTP)

  const handleOtpChange = (e) => {
    if (e.target.value.length > 5) {
      setOtpInput("");
      setValidOtp(false);
    } else {
      setOtpInput(e.target.value);
      setValidOtp(true);
    }
  };

  const submitOtp = () => {
    if (generatedemailotp != otpInput) {
      setValidOtp(false);
    } else {
      setValidOtp(true);
      props.onSubmit();
      // navigate(`${process.env.PUBLIC_URL}/regular-mutual-fund/paymentsucess`);
    }
  };
  const updatenominee = async () => {
    try {
      var res = await apiCall(DMF_UPDATENOMINEE_API_URL, {
        user_id: getUserId(),
        data_belongs_to: DATA_BELONGS_TO,
        is_authenticated: "1"
      });

    } catch (e) {
      console.error(e);
    }

  };

  const fetchSms = async () => {
    var sms_api_id = "fintoo_otp";
    var otp = randomOTP.current;

    setGeneratedSmsOTP(otp);
    var msg = "Greetings from Fintoo! Your OTP verification code is " + otp;
    var whatsapptext =
      "Greetings from Fintoo! Your OTP verification code is : " + otp;
    console.log('whatsapptext', whatsapptext);
    // var urlsms = {
    //   mobile:usermobile,
    //   otp: otp,
    //   amount: getItemLocal('sip_amount'),
    //   // commonEncode.decrypt(localStorage.getItem('cart_amt')),
    //   user_name:username,
    //   key:"multiple_fund_transaction",
    //   is_direct :IS_DIRECT,
    //   msg:msg,
    //   whatsapptext:whatsapptext

    // };
    // var data2 = commonEncode.encrypt(JSON.stringify(urlsms));
    // var config1 = {
    //   method: "post",
    //   url: DMF_SENDSMS_API_URL,
    //   data: data2,
    // };
    // var res = await axios(config1);
    var urlsms = {
      msg: msg,
      mobile: usermobile,
      whatsapptext: whatsapptext,
      sms_api_id: sms_api_id,
    };
    var res = await SendSMs(urlsms)
    var response = commonEncode.decrypt(res.data);
  };

  const fetchMail = async () => {
    setOtpInput("");

    var otp = randomOTP.current;
    setGeneratedEmailOTP(otp);

    // var urlmail = {
    //   userdata: {
    //     to: useremail,
    //   },
    //   subject: "Fintoo - Your one time password",
    //   template: "otp_message_template.html",
    //   contextvar: { otp: otp ,name:username},
    // };

    var urlmail = {
      userdata: {
        to: useremail,
      },
      subject: "Fintoo - Your one time password",
      template: "otp_message_template.html",
      contextvar: { otp: otp, name: username },
    };

    // var data = commonEncode.encrypt(JSON.stringify(urlmail));
    // var config = {
    //   method: "post",
    //   url: DMF_SENDMAIL_API_URL,
    //   data: data,
    // };

    // var res = await axios(config);
    var res = await sendMail(urlmail)
    var response = commonEncode.decrypt(res.data);
  };

  const onLoadInIt = () => {
    SetName(user_data.user_name)
    setnomineeflag(user_data.is_authenticated);
    setuseremail(user_data.user_email);
    setusermobile(user_data.mobile);
  };

  useEffect(() => {
    timer.current.counter = timer.current.default;
    startTimer();
  }, []);

  const startTimer = () => {
    timer.current.obj = setInterval(() => {
      if (timer.current.counter > 0) {
        timer.current.counter = timer.current.counter - 1;
        setCount(timer.current.counter);
      } else {
        clearInterval(timer.current.obj);
        timer.current.counter = timer.current.default;
      }
    }, 1000);
  };

  var props_data = props.value;

  return (
    <>
      <Modal.Header className="py-3">
        <FintooBackButton onClick={() => props.onBack()} />
        <div className="modal-title">Two Factor Authentication</div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <div className="modal-whitepopup-box-item grey-color border-top-0 text-center">
              <p>Please enter OTP sent to</p>
              <p><strong>{useremail}</strong></p>
              <p><strong>{usermobile}</strong></p>
            </div>

            <div className="text-center p-4">
              <input
                type="text"
                maxLength={5}
                minLength={5}
                placeholder="Enter OTP here"
                className="bottom-border-input w-50 text-center grey-color"
                value={otpInput}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => handleOtpChange(e)}
              />
            </div>

            <div className="text-center p-4 grey-color">
              {count == 0 && (
                <p
                  className="pointer blue-color"
                  onClick={() => {
                    startTimer();
                    fetchSms();
                    fetchMail();
                    setValidOtp(true);
                  }}
                >
                  Resend OTP
                </p>
              )}
              {count > 0 && (
                <p>
                  Resend OTP in{" "}
                  <strong>
                    {moment().startOf("day").seconds(count).format("mm:ss")}
                  </strong>
                </p>
              )}
              {validOtp ? <> </> : <p className="red-color">Invalid OTP</p>}
            </div>

            <div
              className="mt-3 switch-fund-btn mobile-bottom-button"
              onClick={() => {
                submitOtp();
              }}
            >
              Submit
            </div>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};
export default Twofactorotpverification;
